import React from 'react';
import PropTypes from 'prop-types';
import './EtchCopyBlockHeader.scss';

const EtchCopyBlockHeader = (props) => {

  const opts = props?.opts;
  const {
    logoMedia,
    heading,
    cta,
    ctaLink,
    linkList,
    subHeading,
    id
  } = opts;

  return (
    <div className="EtchCopyBlockHeader etch-analytics">
      <div className="EtchCopyBlockHeader__padding">
        {logoMedia.src
          && <img src={logoMedia.src} alt={logoMedia.alt} />}
        { ctaLink
          && (
            <a href={ctaLink}>
              <p className="EtchCopyBlockHeader__heading u__large u__display-font--black">
                {heading}
              </p>
            </a>
          )}
        { !ctaLink
          && (
            <p className="EtchCopyBlockHeader__heading u__large u__display-font--black">
              {heading}
            </p>
          )}
        {(ctaLink && subHeading)
          && (
            <a href={ctaLink}>
              <p className="EtchCopyBlockHeader__subHeading u__medium ">{subHeading}</p>
            </a>
          )}
        {(!ctaLink && subHeading)
          && <p className="EtchCopyBlockHeader__subHeading u__medium ">{subHeading}</p>}
        {cta
          && (
            <a className="bttn bttn--primary bttn--inline" href={ctaLink}>
              <span className="bttn__content">{cta}</span>
            </a>
          )}
        {linkList.length > 0
          && (
            <ul className="EtchCopyBlockHeader__link  list list--type-plain" data-module-content-id={id}>
              {linkList.map((link, index) => {
                return (
                  <React.Fragment key={`${index}-${link.linkText}`}>
                    {link?.link
                    && (
                      <li className="list__item ">
                        <a className="list__link" href={link.link}>{link.linkText}</a>
                      </li>
                    )}
                    {!link.link
                    && <li className="list__item">{link.linkText}</li>}
                  </React.Fragment>
                );
              })}
            </ul>
          )}
      </div>
    </div>
  );
};

EtchCopyBlockHeader.displayName = 'EtchCopyBlockHeader';

EtchCopyBlockHeader.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    logoMedia: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    heading: PropTypes.string,
    cta: PropTypes.string,
    ctaLink: PropTypes.string,
    linkList: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string,
      linkText: PropTypes.string
    })),
    subHeading: PropTypes.string,
    type: PropTypes.string
  })
};

EtchCopyBlockHeader.defaultProps = {
  opts: {}
};

export default EtchCopyBlockHeader;
